import React, { useEffect, useState } from "react";
import { listarDistribuidoresDropdown, relatorioFaturamentoComposicao } from "../services/api";
import RelatorioComposicaoView from "./RelatorioComposicaoView";

const RelatorioDistribuidor = ({ token }) => {
  const now = new Date();
  const [distribuidores, setDistribuidores] = useState([]);
  const [distribuidorId, setDistribuidorId] = useState("");
  const [ano, setAno] = useState(String(now.getFullYear()));
  const [mes, setMes] = useState(String(now.getMonth() + 1));
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState(null);

  useEffect(() => {
    listarDistribuidoresDropdown(token)
      .then((r) => setDistribuidores(Array.isArray(r.data) ? r.data : []))
      .catch(() => setDistribuidores([]));
  }, [token]);

  const carregar = async () => {
    if (!distribuidorId) {
      alert("Selecione o distribuidor.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await relatorioFaturamentoComposicao(token, {
        distribuidorId,
        ano: Number(ano),
        mes: Number(mes),
        aplicarCarencia: true,
      });
      setDados(data);
    } catch (e) {
      console.error(e);
      setDados(null);
      alert("Erro ao carregar o relatório.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto zen-card rounded-2xl p-6">
      <div className="flex flex-wrap gap-3 items-end mb-6">
        <div>
          <label className="block text-xs mb-1 dark:text-slate-300">Distribuidor</label>
          <select
            value={distribuidorId}
            onChange={(e) => setDistribuidorId(e.target.value)}
            className="px-3 py-2 rounded-xl border dark:bg-slate-950/40 dark:border-white/10 dark:text-white"
          >
            <option value="">Selecione</option>
            {distribuidores.map((d) => (
              <option key={d.id} value={d.id}>
                {d.nomeFantasia || d.razaoSocial}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-xs mb-1 dark:text-slate-300">Mês</label>
          <input value={mes} onChange={(e) => setMes(e.target.value)} className="w-20 px-3 py-2 rounded-xl border dark:bg-slate-950/40 dark:border-white/10 dark:text-white" />
        </div>
        <div>
          <label className="block text-xs mb-1 dark:text-slate-300">Ano</label>
          <input value={ano} onChange={(e) => setAno(e.target.value)} className="w-24 px-3 py-2 rounded-xl border dark:bg-slate-950/40 dark:border-white/10 dark:text-white" />
        </div>
        <button
          type="button"
          onClick={carregar}
          disabled={loading}
          className="px-4 py-2 rounded-xl bg-blue-600 text-white text-sm font-semibold disabled:opacity-60"
        >
          {loading ? "Carregando..." : "Gerar"}
        </button>
      </div>
      <RelatorioComposicaoView dados={dados} />
    </div>
  );
};

export default RelatorioDistribuidor;
